import type { ReactNode } from "react";
import { Stack } from "@volca/ui/components/ui/stack";
import { SectionLabel } from "./shared";

export const FieldWithAction = ({
  label,
  action,
  children,
}: {
  label: string;
  action?: ReactNode;
  children: ReactNode;
}) => (
  <Stack gap={2}>
    <Stack direction="row" justify="between" align="center" gap={4}>
      <SectionLabel>{label}</SectionLabel>
      {action}
    </Stack>
    {children}
  </Stack>
);
